export type PrometheusMySqlTemporaryTablesStatsBackendApiProps = {
    created: number;
    instance: string;
    created_tmp_tables: number;
    created_tmp_disk_tables: number;
};

export default class PrometheusMySqlTemporaryTablesStats {
    readonly created: number;
    readonly instance: string;
    readonly createdTmpTables: number;
    readonly createdTmpDiskTables: number;

    constructor(props: PrometheusMySqlTemporaryTablesStatsBackendApiProps) {
        this.created = props.created;
        this.instance = props.instance;
        this.createdTmpTables = props.created_tmp_tables;
        this.createdTmpDiskTables = props.created_tmp_disk_tables;
    }
}
